
document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll('.visionary-slide');
  let index = 0;
  function showSlide() {
    slides.forEach(s => s.classList.remove('active'));
    slides[index].classList.add('active');
    index = (index + 1) % slides.length;
  }
  if (slides.length > 0) {
    slides[0].classList.add('active');
    setInterval(showSlide, 5000);
  }
});
